import { createContext, useContext } from 'react';
import { TransitionContextValue } from '~/types/transition';

export const TransitionContext = createContext<TransitionContextValue | undefined>(undefined);

export const useTransitionContext = (): TransitionContextValue => {
  const context = useContext(TransitionContext);
  if (!context) {
    throw new Error('useTransitionContext must be used within a TransitionProvider');
  }
  return context;
};

// Safe to call outside TransitionProvider — returns 0 when not in context (e.g. sidebar)
export const useTransitionAttentionCount = (): number => {
  const context = useContext(TransitionContext);
  return context?.unseenAttentionIds.size ?? 0;
};
